import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EChatModalActionTypes, IOpenChatModalPayload } from './types';

export const openChatModal = actionGenerator<EChatModalActionTypes.Open, IOpenChatModalPayload>(
  EChatModalActionTypes.Open,
);
export const closeChatModal = actionGenerator<EChatModalActionTypes.Close>(EChatModalActionTypes.Close);
